export enum ConditionType {
    SICKNESS = "Sickness",
    PREGNANCY = "Pregnancy",
    INJURY = "Injury"
}